let React       = require("react");
const {  Route, Switch  } = require('react-router-dom');
let Application = require("../Application.js");

let ExLibrary   = require("../controls/explore/ExploreLibraries.jsx");
let ExPackages  = require("../controls/explore/ExplorePackages.jsx");
let Ex3DModels  = require("../controls/explore/Explore3DModels.jsx");

let ExOverView  = require("../controls/explore/ExploreOverview.jsx");

let SiteHeader  = require("../controls/SiteHeader.jsx");
let Cover       = require("../controls/Cover.jsx");
let Footer      = require("../controls/Footer.jsx");

const SECTION_NAME = "explore";

// FILE NOT USED??

class Explore extends React.Component {

    constructor() {
        super()

        this.state = { };

        this.onSearch = this.onSearch.bind(this);
        this.onSectionName = this.onSectionName.bind(this);
    }
    
    componentDidMount() {
        Application.dataStore.getUserInfo();
    }

    onSearch(value){
        this.props.history.push(`/search?q=${value}`);
    }

    onSectionName(sectionName){
        this.setState({ sectionName })
    }

    getConfig(){
        return { search: {url: "", value: ""}, onSectionName: this.onSectionName, type: "Explore"}
    }

    render() {
        return (
            <div className="explore">
                <SiteHeader type="Explore" onSearch={this.onSearch}/>
                <Cover/>
                <Switch>
                    <Route exact path="/explore" render={props => <ExOverView {...this.props} {...props} {...this.getConfig()}/>}/>
                    <Route exact path='/explore/libraries'render={props => <ExLibrary {...this.props} {...props} {...this.getConfig()}/>}/>
                    <Route exact path="/explore/packages" render={props => <ExPackages {...this.props} {...props} {...this.getConfig()}/>}/>
                    <Route exact path="/explore/3dmodels" render={props => <Ex3DModels {...this.props} {...props} {...this.getConfig()}/>}/>
                </Switch>
                <Footer type={SECTION_NAME}/>
            </div>
        )
    }
}

module.exports = Explore;
